module.exports = __webpack_public_path__ + "static/media/champagne_pop.731ba713.svg";